import moment from 'moment'
import { DATE_FORMAT, DATETIME_FORMAT } from '../constants/date'


export function epochTime(): number {
	return Math.floor(Date.now() / 1000)
}

export function hasSecondsPassed(timePeriod: number, refSeconds: number) {
	const currentSeconds = epochTime()
	return currentSeconds - refSeconds >= timePeriod
}

export function formatDateFromSeconds(seconds: number) {
	return moment.unix(seconds).format(DATE_FORMAT)
}

export function formatDateTimeFromSeconds(seconds: number) {
	return moment.unix(seconds).format(DATETIME_FORMAT)
}

export function serializeDate(date: Date) {
	let serializedDate = 0
	serializedDate += date.getFullYear() * 10000
	serializedDate += (date.getMonth() + 1) * 100
	serializedDate += date.getDate()

	return serializedDate
}

export function deserializeDateUTC(serializedDate: string | number) {
  const year = parseInt(serializedDate.toString().substring(0, 4));
  const month = parseInt(serializedDate.toString().substring(4, 6));
  const day = parseInt(serializedDate.toString().substring(6));

  const date = new Date();
  date.setUTCFullYear(year, month -1, day);
  date.setUTCHours(0, 0, 0);
  return date;
}